import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { FileDownloadResponseModel } from '../../models/file-download-response.model';
import { IHttpSingleDataResponse } from '../../../utils/models/http-single-data-response.model';
import { IEnvironment } from '../../models/environment.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private environment: IEnvironment;

  constructor(
    private http: HttpClient,
    @Inject('environment') environment: IEnvironment
  ) {
    this.environment = environment;
  }

  getPaymentReceipt(
    applicationNumber: string,
    locale?: string
  ): Observable<FileDownloadResponseModel> {
    // Add the locale header if provided
    const headers: Record<string, string> = { applicationNumber };
    if (locale) {
      headers['locale'] = locale;
    }
    return this.http
      .get<IHttpSingleDataResponse<FileDownloadResponseModel>>(
        `${this.environment.apiGatewayBaseUrl}/application/v1/payment-receipt`,
        {
          headers: headers,
        }
      )
      .pipe(map(res => res.data));
  }

  getPaymentPublicKey(
    merchant: string
  ): Observable<IHttpSingleDataResponse<any>> {
    return this.http.get<IHttpSingleDataResponse<any>>(
      `${this.environment.apiGatewayBaseUrl}/application/v1/payment-merchant/public-key`,
      {
        headers: { merchant },
      }
    );
  }
}
